const LoadingScreen = () => {

    return (
        <div className="loading-screen">
            <div className="loading-content">
                Loading Phreesh...
            </div>
        </div>
    )
}

export default LoadingScreen